module.exports = "/assets/d5585b53344a34705296c53310912795.png";